module.exports = __webpack_public_path__ + "1cc5743257489ad0da1cd5a269bfaaa4.jpg";